module.exports = __webpack_public_path__ + "front/img/banner.d3ddd95c.png";